/* eslint-disable @typescript-eslint/no-explicit-any */
import { IInfoPresenter } from './IInfoPresenter'

export class InfoPresentersRegister {
    private repository = new Map<string, IInfoPresenter<any>>()

    addInfoPresenter(infoPresenter: IInfoPresenter<any>): void {
        this.repository.set(infoPresenter.presenterCode, infoPresenter)
    }

    removeInfoPresenter(infoPresenter: IInfoPresenter<any>): void {
        this.repository.delete(infoPresenter.presenterCode)
    }

    getInfoPresenter(presenterCode: string): IInfoPresenter<any> {
        return this.repository.get(presenterCode)
    }
}

export const infoPresentersRegister = new InfoPresentersRegister()
